import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Card from '../../components/common/Card';
import FormInput from '../../components/forms/FormInput';
import Button from '../../components/common/Button';
import { passwordResetService } from '../../services/passwordReset.service';
import { useForm } from '../../hooks/useForm';
import { validators } from '../../utils/validators';
import { theme } from '../../config/theme';
import { CheckCircleIcon } from '../../components/icons/Icons';

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const { values, errors, touched, handleChange, handleBlur, validate } = useForm(
    { email: '' },
    { email: (value) => validators.email(value) }
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    try {
      const response = await passwordResetService.requestReset(values.email);
      setSuccess(true);
    } catch (error) {
      alert(error.response?.data?.message || 'Failed to send reset email');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div style={{ width: '100%', maxWidth: '450px' }}>
        <div style={{ textAlign: 'center', marginBottom: theme.spacing['2xl'] }}>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <h1 style={{ fontSize: theme.typography.fontSize['4xl'], fontWeight: theme.typography.fontWeight.bold, color: theme.colors.primary.main, marginBottom: theme.spacing.md }}>
              AlarcTrade
            </h1>
          </Link>
        </div>

        <Card padding="xl">
          <div style={{ textAlign: 'center' }}>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              marginBottom: theme.spacing.lg, 
              color: theme.colors.success 
            }}>
              <CheckCircleIcon size={48} />
            </div>
            <h2 style={{ fontSize: theme.typography.fontSize['2xl'], fontWeight: theme.typography.fontWeight.bold, marginBottom: theme.spacing.md }}>
              Check Your Email
            </h2>
            <p style={{ fontSize: theme.typography.fontSize.sm, color: theme.colors.text.secondary, marginBottom: theme.spacing.xl }}>
              If an account exists with <strong>{values.email}</strong>, you will receive password reset instructions.
            </p>
            <Link to="/login" style={{ color: theme.colors.primary.main, textDecoration: 'none', fontWeight: theme.typography.fontWeight.medium }}>
              ← Back to Login
            </Link>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div style={{ width: '100%', maxWidth: '450px' }}>
      <div style={{ textAlign: 'center', marginBottom: theme.spacing['2xl'] }}>
        <Link to="/" style={{ textDecoration: 'none' }}>
          <h1 style={{ fontSize: theme.typography.fontSize['4xl'], fontWeight: theme.typography.fontWeight.bold, color: theme.colors.primary.main, marginBottom: theme.spacing.md }}>
            AlarcTrade
          </h1>
        </Link>
        <p style={{ fontSize: theme.typography.fontSize.base, color: theme.colors.text.secondary }}>
          Reset your password
        </p>
      </div>

      <Card padding="xl">
        <h2 style={{ fontSize: theme.typography.fontSize['2xl'], fontWeight: theme.typography.fontWeight.bold, textAlign: 'center', marginBottom: theme.spacing.md }}>
          Forgot Password?
        </h2>
        <p style={{ fontSize: theme.typography.fontSize.sm, color: theme.colors.text.secondary, textAlign: 'center', marginBottom: theme.spacing.xl }}>
          Enter your email and we'll send you instructions to reset your password
        </p>

        <form onSubmit={handleSubmit}>
          <FormInput
            label="Email Address"
            name="email"
            type="email"
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="your@email.com"
            error={errors.email}
            touched={touched.email}
            required
          />

          <Button type="submit" fullWidth loading={loading} disabled={loading}>
            Send Reset Link
          </Button>
        </form>

        <div style={{ marginTop: theme.spacing.xl, textAlign: 'center', fontSize: theme.typography.fontSize.sm, color: theme.colors.text.secondary }}>
          Remember your password?{' '}
          <Link to="/login" style={{ color: theme.colors.primary.main, textDecoration: 'none', fontWeight: theme.typography.fontWeight.medium }}>
            Sign In
          </Link>
        </div>
      </Card>
    </div>
  );
};

export default ForgotPassword;